import React from "react";

const ChargesScreen = () => {
  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center bg-[#1A1A1A] px-4 py-10">
      <h1 className="mb-6 text-white text-3xl sm:text-4xl text-center">Тарифы и цены</h1>
      <p className="text-white text-base sm:text-lg md:text-xl font-light text-center max-w-[600px]">
        В каждом абонементе есть бесплатные гостевые для друзей и дни заморозки
      </p>

      {/* Cards Container */}
      <div className="mt-20 flex flex-wrap justify-center gap-8">
        {/* Card 1 */}
        <div className="w-full sm:w-[280px] max-w-sm bg-white border border-gray-200 rounded-lg shadow-sm p-4 sm:p-6">
          <h5 className="mb-4 text-[24px] font-medium text-black">Standard plan</h5>
          <div className="flex items-baseline text-gray-900">
            <span className="text-[13px] font-normal text-slate-400">What is waiting for you?</span>
          </div>
          <ul className="space-y-5 my-4">
            <li className="flex items-center">
              <svg
                className="shrink-0 w-4 h-4 text-[#4E2D92]"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
              </svg>
              <span className="text-base font-normal leading-tight text-black ml-3">2 team members</span>
            </li>
            <li className="flex items-center">
              <svg
                className="shrink-0 w-4 h-4 text-[#4E2D92]"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 1 1 1.414 1.414Z" />
              </svg>
              <span className="text-base font-normal leading-tight text-black ml-3">20GB Cloud storage</span>
            </li>
            <li className="flex items-center">
              <svg
                className="shrink-0 w-4 h-4 text-[#4E2D92]"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 1 1 1.414 1.414Z" />
              </svg>
              <span className="text-base font-normal leading-tight text-black ml-3">Integration help</span>
            </li>
          </ul>
          <button
            type="button"
            className="mt-6 text-[#C1272D] text-[12px] bg-[#C1272D1A] hover:bg-red-100 focus:ring-1 focus:outline-none font-medium rounded-lg px-5 py-2.5 inline-flex justify-center w-full text-center"
          >
            Choose plan
          </button>
        </div>

        {/* Card 2 */}
        <div className="w-full sm:w-[427px] max-w-sm bg-[#303030] rounded-lg shadow-sm p-6">
          {/* Top row */}
          <div className="flex justify-between items-start mb-4">
            <h5 className="text-[24px] font-medium text-[#FCC107]">VIP Абонемент</h5>
            <button
              type="button"
              className="w-28 h-11 text-white bg-[#C1272D] font-medium rounded-full text-[14px] text-center"
            >
              Рекомендуем
            </button>
          </div>
          <div className="flex items-baseline">
            <span className="text-[13px] font-normal text-slate-400">
              На 3, 6, 12 месяцев
            </span>
          </div>
          <ul className="space-y-5 my-4">
            <li className="flex items-center">
              <svg
                className="shrink-0 w-4 h-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 1 1 1.414 1.414Z" />
              </svg>
              <span className="text-base font-normal leading-tight text-white ml-3">
                2 team members
              </span>
            </li>
            <li className="flex items-center">
              <svg
                className="shrink-0 w-4 h-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 1 1 1.414 1.414Z" />
              </svg>
              <span className="text-base font-normal leading-tight text-white ml-3">
                20GB Cloud storage
              </span>
            </li>
            <li className="flex items-center">
              <svg
                className="shrink-0 w-4 h-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 1 1 1.414 1.414Z" />
              </svg>
              <span className="text-base font-normal leading-tight text-white ml-3">
                Integration help
              </span>
            </li>
          </ul>
          <button
            type="button"
            className="mt-6 text-[#C1272D] text-[12px] bg-white hover:bg-red-100 font-medium rounded-lg px-5 py-2.5 inline-flex justify-center w-full text-center"
          >
            Choose plan
          </button>
        </div>

        {/* Card 3 (same styling as Card 2) */}
        <div className="w-full sm:w-[427px] max-w-sm bg-[#303030] rounded-lg shadow-sm p-6">
          <div className="flex justify-between items-start mb-4">
            <h5 className="text-[24px] font-medium text-[#FCC107]">VIP Абонемент</h5>
            <button
              type="button"
              className="w-28 h-11 text-white bg-[#C1272D] font-medium rounded-full text-[14px] text-center"
            >
              Рекомендуем
            </button>
          </div>
          <div className="flex items-baseline">
            <span className="text-[13px] font-normal text-slate-400">
              На 3, 6, 12 месяцев
            </span>
          </div>
          <ul className="space-y-5 my-4">
            <li className="flex items-center">
              <svg
                className="shrink-0 w-4 h-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 1 1 1.414 1.414Z" />
              </svg>
              <span className="text-base font-normal leading-tight text-white ml-3">
                2 team members
              </span>
            </li>
            <li className="flex items-center">
              <svg
                className="shrink-0 w-4 h-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 1 1 1.414 1.414Z" />
              </svg>
              <span className="text-base font-normal leading-tight text-white ml-3">
                20GB Cloud storage
              </span>
            </li>
            <li className="flex items-center">
              <svg
                className="shrink-0 w-4 h-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 1 1 1.414 1.414Z" />
              </svg>
              <span className="text-base font-normal leading-tight text-white ml-3">
                Integration help
              </span>
            </li>
          </ul>
          <button
            type="button"
            className="mt-6 text-[#C1272D] text-[12px] bg-white hover:bg-red-100 font-medium rounded-lg px-5 py-2.5 inline-flex justify-center w-full text-center"
          >
            Choose plan
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChargesScreen;
